<adaa-adaa4-stepper [current]="3" [notificationId]="id()" />

@if (loaded()) {
    @if (notification(); as n) {
        @if (result(); as outcome) {
            <section class="panel result">
                <span class="result-icon result-icon--{{ outcome }}">
                    @if (outcome === "approved") {
                        <svg
                            viewBox="0 0 24 24"
                            width="30"
                            height="30"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            aria-hidden="true"
                        >
                            <path d="m5 12.5 4.5 4.5L19 7.5" />
                        </svg>
                    } @else {
                        <svg
                            viewBox="0 0 24 24"
                            width="30"
                            height="30"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2.2"
                            stroke-linecap="round"
                            aria-hidden="true"
                        >
                            <path d="M6 6l12 12M18 6 6 18" />
                        </svg>
                    }
                </span>
                <h1 class="page-title">{{ "adaa4.notification." + outcome + "_title" | translate }}</h1>
                <p class="page-eyebrow">{{ AdaaHelper.getItemValueByToken(n, "itemName") || AdaaHelper.getItemValueByToken(n, "title") }}</p>
                <p class="muted">{{ "adaa4.notification.decision_note" | translate }}</p>
                <a class="btn btn--primary" routerLink="/homepage/notifications">{{ "adaa4.notification.back_to_list" | translate }}</a>
            </section>
        } @else {
            <div class="page-head">
                <div>
                    <h1 class="page-title">{{ "adaa4.notification.action_title" | translate }}</h1>
                    <p class="page-eyebrow">
                        <span class="chip chip--{{ actionType() }}">
                            @if (actionType() === "other") {
                                {{ AdaaHelper.getItemValueByToken(n, "itemTypeName") }}
                            } @else {
                                {{ "adaa4.action_" + actionType() | translate }}
                            }
                        </span>
                        {{ AdaaHelper.getItemValueByToken(n, "itemName") || AdaaHelper.getItemValueByToken(n, "title") }}
                    </p>
                </div>
            </div>

            @if (isPending()) {
                <section class="panel decision-panel">
                    <div class="decision-grid">
                        <div class="decision-form">
                            <adaa-wf-override-decision #overrideDecision [label]="''" (emitDecision)="decision.set($event)" />
                        </div>
                        <div class="comments">
                            <h2 class="comments-title">{{ "common.form.label.comments" | translate }}</h2>
                            <div class="comments-list">
                                @for (comment of addedComments(); track $index) {
                                    <article class="comment">
                                        <header>
                                            <strong>
                                                {{ AdaaHelper.getItemValueByToken(overrideDecision.getCommentCategory(comment.categoryId), "name") }}
                                            </strong>
                                            <button
                                                type="button"
                                                class="comment-remove"
                                                [attr.aria-label]="'tooltips.delete' | translate"
                                                (click)="overrideDecision.removeComment($index)"
                                            >
                                                <span aria-hidden="true">×</span>
                                            </button>
                                        </header>
                                        <p>{{ comment.comments }}</p>
                                    </article>
                                }
                                @if (!addedComments().length) {
                                    <p class="comments-empty">{{ "adaa4.notification.no_comments" | translate }}</p>
                                }
                            </div>
                        </div>
                    </div>
                    <p class="field-label">{{ "adaa4.notification.attachments" | translate }}</p>
                    <div class="dropzone">
                        <adaa-form-input-file
                            [onDeleteRemoveFile]="false"
                            [allowedFileSize]="10000000"
                            [allowedFiles]="allowedFiles"
                            (inputChanges)="attachment.set($event)"
                        />
                    </div>
                </section>
            } @else {
                <p class="notice" role="note">{{ "adaa4.notification.already_decided" | translate }}</p>
            }

            <div class="action-bar">
                <a class="btn btn--ghost" [routerLink]="['/homepage/notifications', id()]">
                    <span class="btn-arrow btn-arrow--back" aria-hidden="true">←</span>
                    {{ "adaa4.notification.back" | translate }}
                </a>
                @if (isPending()) {
                    <span class="action-bar-spacer"></span>
                    <button type="button" class="btn btn--reject" [disabled]="!canReject() || submitting()" (click)="submit(false)">
                        {{ "common.form.button.reject" | translate }}
                    </button>
                    <button type="button" class="btn btn--approve" [disabled]="submitting()" (click)="submit(true)">
                        {{ "common.form.button.approve" | translate }}
                    </button>
                }
            </div>
        }
    } @else {
        <section class="panel empty-state">
            <p>{{ "adaa4.notification.not_found" | translate }}</p>
            <a class="btn btn--ghost" routerLink="/homepage/notifications">{{ "adaa4.notification.back_to_list" | translate }}</a>
        </section>
    }
}
